"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelationshipToMM = RelationshipToMM;
exports.RequestCategory = RequestCategory;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _Checkbox = _interopRequireDefault(require("../Common/Checkbox"));
var _data = require("../data.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RelationshipToMM(_ref) {
  var {
    formik
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Relationship to MassMutual*"), formik.errors.relationshipToMM && formik.touched.relationshipToMM ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'block'
    },
    className: "custom-feedback invalid-feedback mm-spacing--minor"
  }, formik.errors.relationshipToMM) : '', /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.consumer
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.workforceMember
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Are you an authorized Agent? "), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.authorizedAgent
  }));
}
function RequestCategory(_ref2) {
  var {
    formik
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Type of request*"), formik.errors.requestCategory && formik.touched.requestCategory ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'block'
    },
    className: "custom-feedback invalid-feedback mm-spacing--minor"
  }, formik.errors.requestCategory) : '', /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.requestToKnowCategories
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.requestToDelete
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.requestToKnowSpecificData
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    formik: formik,
    config: _data.componentConfig.requestToCorrect
  }));
}